import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { IProgramTemplate } from 'typings/doenkids/doenkids';
import { ITemplateSearchState, TemplateSearchStore } from './template-search.store';

@Injectable({ providedIn: 'root' })
export class TemplateSearchQuery extends QueryEntity<ITemplateSearchState, IProgramTemplate> {
  constructor(protected store: TemplateSearchStore) {
    super(store);
  }

  get getAggregations() {
    return this.select((value) => value.aggregations);
  }

  get getSuggestions() {
    return this.select((value) => value.suggest);
  }

  get getMetadata() {
    return this.select((value) => ({
      total: value.total,
      skip: value.skip,
      limit: value.limit,
      query: value.query,
      aggregations: value.aggregations,
      took: value.took,
      suggest: value.suggest,
    }));
  }
}
